var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPisces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12pt",
    height: "12pt",
    viewBox: "0 0 12 12",
    id: "svg13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 80.398438 V 80.398438 H 0 Z m 0,0",
    id: "path2-3-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 80.398438 V 80.398438 H 0 Z m 0,0",
    id: "path2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g885"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.14925,0,0,0.14925,-1.08e-4,4.48e-4)",
    style: {
      stroke: "#000000",
      strokeWidth: 4.0201005,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeLinejoin: "round",
      strokeLinecap: "round"
    },
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    transform: "matrix(0.1,0,0,-0.1,0,80.4)",
    d: "M 66.992188,402.00781 H 736.99219",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40.20100503,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 4.0201005,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      strokeLinejoin: "round",
      strokeLinecap: "round"
    },
    id: "g13",
    clipPath: "url(#clip1-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9-2",
    transform: "matrix(0.1,0,0,-0.1,0,80.4)",
    d: "m 192.61719,111.89063 c 103.67187,59.84374 167.5,170.42968 167.5,290.11718 0,119.6875 -63.82813,230.27344 -167.5,290.11719",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40.20100503,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    transform: "matrix(0.1,0,0,-0.1,0,80.4)",
    d: "m 611.36719,692.125 c -103.63282,-59.84375 -167.5,-170.42969 -167.5,-290.11719 0,-119.6875 63.86718,-230.27344 167.5,-290.11718",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40.20100503,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisces);
export default __webpack_public_path__ + "static/media/pisces.04146d28c1e6d168e005da1eb72c89b3.svg";
export { ForwardRef as ReactComponent };